import { render, staticRenderFns } from "./stackBar.vue?vue&type=template&id=2896eb62&scoped=true&"
import script from "./stackBar.vue?vue&type=script&lang=js&"
export * from "./stackBar.vue?vue&type=script&lang=js&"
import style0 from "./stackBar.vue?vue&type=style&index=0&id=2896eb62&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2896eb62",
  null
  
)

export default component.exports